module.exports = __webpack_public_path__ + "static/media/41_A.601e9668.png";